module.exports = __webpack_public_path__ + "static/img/item4.6eea7f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item4.png
// module id = 4zEE
// module chunks = 63